/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import classnames from 'classnames';
import { IProofPointsData } from './proof-points.data';
import { IProofPointsProps } from './proof-points.props.autogenerated';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';

export interface IProofPointsViewProps extends IProofPointsProps<IProofPointsData> {
    proofPoints: IModuleProps;
    proofPointsContainer: INodeProps;
    proofPointsNode: React.ReactNode;
}

/**
 *
 * ProofPoints component
 * @extends {React.PureComponent<IProofPointsProps<IProofPointsData>>}
 */
class ProofPoints extends React.PureComponent<IProofPointsProps<IProofPointsData>> {
    public render(): JSX.Element | null {
        const viewprops = {
            ...this.props,
            proofPoints: {
                moduleProps: this.props,
                className: classnames('proof-points')
            },
            proofPointsContainer: {
                moduleProps: this.props,
                className: classnames('proof-points-container')
            },
            proofPointsNode: this._renderProofPoint()
        };
        return this.props.renderView(viewprops) as React.ReactElement;
    }
    private _renderProofPoint(): JSX.Element | null {
        if (!this.props.slots || !this.props.slots.content || this.props.slots.content.length === 0) {
            this.props.context.telemetry.error('slots content is empty, module wont render');
            return null;
        }
        return (
            <>
                <div className='proof-points-grid'>{this.props.slots.content}</div>
            </>
        );
    }
}

export default ProofPoints;
